export const rebookingWrapper = `
  h2 {
    font-weight: bold;
    font-size: 20px;
    color: #223254;
    margin: 0 0 24px;
  }
  
  .order-actions {
    button {
      height: 34px;
      width: 190px;
      display: flex;
      align-items: center;
      justify-content: center;

      &:disabled {
        background: #d8dcde;
        box-shadow: none;
        color: #879395;
      }

      i {
        width: 24px;
        height: 24px;
      }
    }
  }
`;

export const rebookingModal = `
  max-width: 600px;
  color: #6e798e;
  font-weight: 500;

  .modal-thumbnail {
    display: block;
    margin: 0 auto;
  }

  .modal-row {
    display: flex;
    flex-wrap: wrap;
    margin: 24px 0;
    margin-left: -16px;

    &.airport-autocomplete {
      input {
        box-shadow: none !important;
      }
    }

    &.column {
      flex-direction: column;
    }

    &.no-margin-top {
      margin-top: 0;
    }

    &.less-margin-bottom {
      margin-bottom: 12px;
    }

    &.no-margin {
      margin: 0;
    }

    > * {
      flex: 1;
      margin-left: 16px;
    }
  }

  h2 {
    font-weight: bold;
    font-size: 22px;
    color: #223254;
    margin: 24px 0;
  }

  h3 {
    font-weight: bold;
    font-size: 16px;
    color: #223254;
    margin: 24px 0;
  }

  input[type=checkbox] {
    margin-bottom: 8px;
  }

  .modal-info {
    display: flex;

    i {
      font-size: 22px;
      margin-right: 16px;
    }
  }

  .modal-buttons {
    margin-top: 16px;
    display: flex;
    align-items: center;

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px 64px;
      margin-left: 16px;
      width: max-content;
      max-width: 189px;
    }

    button:disabled {
      background: #d8dcde;
      box-shadow: none;
      color: #879395;
      border: 0;
    }

    i {
      width: 18px;
      height: 18px;
    }
  }

  .loader-container {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 24px 24px;

    .loader {
      width: 48px;
      height: 48px;
    }
  }
`;

export const rebookingErrorModal = `
  max-width: 400px;

  .title {
    margin: 0 0 12px;
    font-weight: bold;
    color: #223254;
  }
`

export const modalSteps = (step, total) => `
  flex: 1;
  height: 8px;
  background: #d8d8d8;
  border-radius: 50px;
  position: relative;
  overflow: hidden;
  transition: all .3s;

  &:after {
    position: absolute;
    content: ' ';
    height: 100%;
    width: ${(step / total) * 100}%;
    background: #1abc9c;
    border-radius: 20px;
    transition: all .3s;
  }
`;